import { useEffect, useState } from "react";
import { Typography, Link, Box } from "@mui/material";

const CountdownTimer = ({ initialTime, onComplete }) => {
    const [timeLeft, setTimeLeft] = useState(initialTime);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(timer);
        } else {
            onComplete();
        }
    }, [timeLeft, onComplete]);

    return (
        <Typography variant="body1" fontWeight="bold" sx={{ fontSize: 11, padding: 0 }}>
            Kalan Süre: {timeLeft} saniye
        </Typography>
    );
};

export default CountdownTimer;